import React, { Suspense, lazy } from 'react';
const Classify = lazy(() => import('./components/Classify'));

export default function puzzle(props) {
  return (
    <Suspense fallback={<div />}>
      <Classify {...props} />
    </Suspense>
  );
}
